/** Keep failures visible without guessing whether a passphrase or service failed. */
export const privateErrorMessage = (
  cause: unknown,
  fallback = "Private Mode could not complete this request. Please try again."
): string => {
  if (typeof cause === "string" && cause.trim()) return cause.trim();
  if (cause && typeof cause === "object" && "message" in cause) {
    const message = cause.message;
    if (typeof message === "string" && message.trim()) return message.trim();
  }
  return fallback;
};

/** Only explicit wallet cancellation codes prove the signing request was rejected. */
export const isDefinitiveWalletRejection = (cause: unknown): boolean => {
  if (!cause || typeof cause !== "object" || !("code" in cause)) return false;
  return cause.code === 4001 || cause.code === "ACTION_REJECTED";
};
